import React, { useEffect, useMemo, useState } from "react";
import { buildRenderableBanquetImages } from "../../utils/banquetImageUtils.js";

export default function BanquetGallery({ images, name }) {
  const [failedImages, setFailedImages] = useState([]);
  const safeImages = useMemo(() => buildRenderableBanquetImages(images), [images]);
  const availableImages = useMemo(() => {
    const filteredImages = safeImages.filter((image) => !failedImages.includes(image));
    return filteredImages.length ? filteredImages : buildRenderableBanquetImages([]);
  }, [failedImages, safeImages]);
  const thumbnailImages = availableImages.slice(0, 5);
  const [activeImage, setActiveImage] = useState(availableImages[0]);

  useEffect(() => {
    setFailedImages([]);
  }, [safeImages]);

  useEffect(() => {
    if (!activeImage || failedImages.includes(activeImage) || !availableImages.includes(activeImage)) {
      setActiveImage(availableImages[0]);
    }
  }, [activeImage, availableImages, failedImages]);

  const markImageFailed = (image) => {
    setFailedImages((current) => (current.includes(image) ? current : [...current, image]));
  };

  return (
    <section className="grid min-w-0 items-start gap-3 overflow-hidden sm:gap-4 lg:grid-cols-[minmax(0,1fr)_180px]">
      <div className="relative overflow-hidden rounded-[24px] bg-slate-100 shadow-[0_34px_100px_-46px_rgba(15,23,42,0.75)] sm:rounded-[34px]">
        <div className="aspect-[4/3] w-full sm:aspect-[16/10] lg:h-[560px] lg:aspect-auto">
          <img
            src={activeImage}
            alt={name}
            className="h-full w-full object-cover"
            onError={() => markImageFailed(activeImage)}
          />
        </div>
      </div>
      <div className="grid min-w-0 grid-cols-3 gap-2 sm:grid-cols-5 sm:gap-3 lg:h-[560px] lg:grid-cols-1 lg:auto-rows-fr">
        {thumbnailImages.map((image) => (
          <button
            key={image}
            type="button"
            onClick={() => setActiveImage(image)}
            className={`min-h-[72px] min-w-0 overflow-hidden rounded-2xl border-2 bg-white transition sm:rounded-3xl ${
              activeImage === image ? "border-amber-400 shadow-lg" : "border-white shadow-sm"
            }`}
          >
            <img
              src={image}
              alt={`${name} preview`}
              loading="lazy"
              className="h-20 w-full object-cover sm:h-28 lg:h-full"
              onError={() => markImageFailed(image)}
            />
          </button>
        ))}
      </div>
    </section>
  );
}
